import { useProfile } from "../../../providers/profile";

import { SkillInstance } from "../../../src/API";

import SkillInstanceDetails from "./cards/skill-instance-details";
import TutorialVideos from "./cards/tutorial-videos";
import ResponseVideos from "./cards/response-videos";
import ExternalVideos from "./cards/external-videos";
import SupportingDocuments from "./cards/supporting-documents";
import Notes from "./cards/notes";
import PersonalTutorials from "./cards/personal-tutorials";

const SkillInstanceView = ({
  skill,
  refresh,
}: {
  skill: Partial<SkillInstance>;
  refresh: () => Promise<void>;
}) => {
  const { account } = useProfile();

  return (
    <div className="lg:flex gap-4">
      <div className="flex flex-col gap-4 mb-4 lg:mb-0 lg:w-1/2">
        <div>
          <SkillInstanceDetails
            instance={skill}
            refresh={refresh}
          ></SkillInstanceDetails>
        </div>
        <div>
          <PersonalTutorials
            refresh={refresh}
            instance={skill}
            editable={
              !!account?.roles?.some((r) =>
                ["teacher", "admin", "superadmin"].includes(r as string)
              )
            }
          ></PersonalTutorials>
        </div>
        <div>
          <ResponseVideos refresh={refresh} instance={skill}></ResponseVideos>
        </div>
      </div>
      <div className="flex flex-col gap-4 lg:w-1/2">
        <div>
          {skill.template ? (
            <ExternalVideos
              template={skill.template!}
              refresh={refresh}
              editable={
                !!account?.roles?.some((r) =>
                  ["teacher", "admin", "superadmin"].includes(r as string)
                )
              }
            ></ExternalVideos>
          ) : null}
        </div>
        <div>
          {skill.template ? (
            <TutorialVideos
              template={skill.template!}
              refresh={refresh}
              editable={
                !!account?.roles?.some((r) =>
                  ["teacher", "admin", "superadmin"].includes(r as string)
                )
              }
            ></TutorialVideos>
          ) : null}
        </div>
        <div>
          {skill.template ? (
            <SupportingDocuments
              template={skill.template!}
              refresh={refresh}
              editable={
                !!account?.roles?.some((r) =>
                  ["teacher", "admin", "superadmin"].includes(r as string)
                )
              }
            ></SupportingDocuments>
          ) : null}
        </div>
        <div>
          <Notes
            instance={skill}
            refresh={refresh}
            editable={
              !!account?.roles?.some((r) =>
                ["teacher", "admin", "superadmin"].includes(r as string)
              )
            }
          ></Notes>
        </div>
      </div>
    </div>
  );
};

export default SkillInstanceView;
